import { News, NewsVerbose } from './types';

export function createCardNews(
	id: number = -1,
	title: string = ``,
	description: string = ``,
	flavor: string = ``
): News {
	const type = 'News';

	return {
		id,
		title,
		description,
		flavor,
		type,
	};
}

export function createCardNewsVerbose(news: News, action: any): NewsVerbose {
	return {
		...news,
		action,
	};
}
